<div *ngIf="!isPrompt">
  <h1 mat-dialog-title class="text-center mb-2">
    Confirmation {{ _data.isUtilizationText ? "for Usage" : "" }}
  </h1>
  <div mat-dialog-content class="mat-typography text-center">
    {{
      _data.isUtilizationText
        ? "Record is already in use. Do
  you still want to delete it?"
        : " Are you sure you want to delete?"
    }}
  </div>
  <div
    mat-dialog-actions
    class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-center mt-4"
  >
    <button
      mat-stroked-button
      class="g-btn g-tertiary-btn"
      cdkFocusInitial
      (click)="yes()"
    >
      Yes
    </button>
    <button mat-flat-button class="g-btn g-primary-btn" (click)="no()">
      No
    </button>
  </div>
</div>

<div *ngIf="isPrompt">
  <div class="g-small-model">
    <h2
      mat-dialog-title
      class="fw-bold text-center mb-2 confirm-dialog-heading"
    >
      Alert!
    </h2>
    <mat-dialog-content
      class="mat-typography text-center confirm-dialog-content m-auto p-0"
    >
      <h4>{{ msg }}</h4>
    </mat-dialog-content>
    <mat-dialog-actions
      class="action-buttons-wrapper align-content-center align-items-center d-flex gap-2 justify-content-center mt-4 mb-auto p-0"
    >
      <button mat-flat-button (click)="close()" class="g-btn g-primary-btn">
        Close
      </button>
    </mat-dialog-actions>
  </div>
</div>
